(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form-categorized"] && !Shopify.designMode) return;
  try {
    class ContactFormCategories extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-category-tab]'))
      this.categoryInput = this.querySelector('[data-category-input]')
      this.form = this.querySelector('form')

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.#selectTab(tab))
      })

      this.form?.addEventListener('submit', () => this.#tagBodyWithCategory())
    }

    #selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab
        tab.classList.toggle('is-active', isSelected)
        tab.setAttribute('aria-selected', String(isSelected))
      })

      if (this.categoryInput) this.categoryInput.value = selectedTab.textContent.trim()
    }

    #tagBodyWithCategory() {
      const body = this.form?.querySelector('[name="contact[body]"]')
      const category = this.categoryInput?.value

      if (!body || !category || body.value.startsWith(`[${category}]`)) return

      body.value = `[${category}] ${body.value}`
    }
  }

  if (!customElements.get('contact-form-categories')) {
    customElements.define('contact-form-categories', ContactFormCategories)
  }
  } catch(e) { console.error(e); }
})();

})();
